var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3721_125447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.313 27.313C29.9305 24.6956 31.5596 21.2515 31.9225 17.5676C32.2854 13.8837 31.3597 10.188 29.3032 7.11007C27.2466 4.03218 24.1865 1.76259 20.6442 0.688012C17.1019 -0.386563 13.2965 -0.199632 9.8766 1.21696C6.45666 2.63354 3.6337 5.19214 1.88875 8.45677C0.143788 11.7214 -0.415204 15.4901 0.307014 19.1207C1.02923 22.7513 2.98797 26.0191 5.84949 28.3674C8.711 30.7157 12.2982 31.9991 16 31.999C20.2431 31.9989 24.3125 30.3133 27.313 27.313Z",
    fill: "#23BF9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 17L13 21L23 11",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3721_125447"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.999,
    height: 31.999,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.534b04d3d359920e7df4ad5b9b74aed0.svg";
export { ForwardRef as ReactComponent };